import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpHandlerFn, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService, UserService } from '@inera/common';
import { SessionService } from '../services/session.service';
import { Router } from '@angular/router';

const excludedUrls: string[] = ['/api/user'];

export const AuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const userService = inject(UserService);
  const sessionService = inject(SessionService);
  const errorHandlerService = inject(ErrorHandlerService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        const isExcluded = excludedUrls.some(url => error.url?.includes(url));

        if (!isExcluded) {
          userService.setUser(null);
          sessionService.setUser(null);
          router.navigate(['/loggedout']);
        }
      } else {
        return errorHandlerService.error(error);
      }
      return throwError(() => error);
    })
  );
};
